import * as angular from "angular";
import * as _ from "lodash";
import {BringozUnitConversionService} from "../services/bringoz-unit-conversion.service";


angular
  .module('bringoz.admin.commons')
  .filter('bringozPriceBySmallDistanceUnit', bringozPriceBySmallDistanceUnit);

function bringozPriceBySmallDistanceUnit(splitService, $filter, bringozUnitConversionService: BringozUnitConversionService) {
  const currency = splitService.getCurrencyCode();

  return function bringozPriceByShortDistanceFilter(price, defaultValue) {
    if (_.isUndefined(price)) {
      return defaultValue || '--';
    }

    return $filter('isoCurrency')((bringozUnitConversionService.pricePerMeterToSmallUnit(price)).toFixed(2), currency);
  }
}
